import React from 'react';

const Ears = ({ left, right, color , scale, rotation }) => {
  return (
    <g>
      <g transform={`translate(${left.x}, ${left.y}) scale(${scale}) rotate(${rotation})`}>
        <path 
          d="M90.8361 74.1518C90.3986 72.551 91.9866 71.137 93.5257 71.7575L297.959 154.17C299.387 154.745 299.657 156.651 298.444 157.6L125.274 293.111C123.898 294.188 121.872 293.124 121.984 291.38C122.964 276.09 125.28 225.105 116.363 180.519C107.384 135.623 94.5958 87.9055 90.8361 74.1518Z" 
          fill={color}
        />
        <path 
          d="M100.298 88.9597C129.313 155.005 133.22 238.348 131.548 271.764C165.645 223.31 190.375 180.71 174.245 146.587C162.353 121.431 115.192 99.9346 100.298 88.9597Z" 
          fill="white" 
          fillOpacity="0.4"
        />
      </g>
      <g transform={`translate(${right.x}, ${right.y}) scale(-${scale}, ${scale}) rotate(${rotation})`}>
        <path 
          d="M90.8361 74.1518C90.3986 72.551 91.9866 71.137 93.5257 71.7575L297.959 154.17C299.387 154.745 299.657 156.651 298.444 157.6L125.274 293.111C123.898 294.188 121.872 293.124 121.984 291.38C122.964 276.09 125.28 225.105 116.363 180.519C107.384 135.623 94.5958 87.9055 90.8361 74.1518Z" 
          fill={color}
        />
        <path 
          d="M100.298 88.9597C129.313 155.005 133.22 238.348 131.548 271.764C165.645 223.31 190.375 180.71 174.245 146.587C162.353 121.431 115.192 99.9346 100.298 88.9597Z" 
          fill="white" 
          fillOpacity="0.4"
        />
      </g>
    </g>
  );
}

export default Ears;
